<div *ngFor="let attachedFile of attachedFiles; let i = index">
  <div class="file-container">
    <div class="flex-space-between">
      <div class="flex full-width">
        <prlw-icon
          name="upload-file"
          class="icon-upload-file"
          [class.grey]="hasError(attachedFile)"
        ></prlw-icon>
        <div class="file-name-progress">
          <div class="file-name" [class.grey]="hasError(attachedFile)">
            {{ attachedFile.fileName }}
          </div>
          <div class="progress" *ngIf="hasProgress(attachedFile)">
            <prlw-file-upload-progress [progress]="attachedFile.progress">
            </prlw-file-upload-progress>
          </div>
          <div *ngIf="hasError(attachedFile)" class="red">
            {{ attachedFile.error }}
          </div>
        </div>
      </div>
      <img
        *ngIf="!attachedFile.pending"
        class="cross-circle-grey"
        src="/assets/icons/cross-circle-grey.svg"
        (click)="eventRemoveAttachedFile.emit(attachedFile.fileName)"
        alt="pending"
      />
    </div>
    <div
      *ngIf="attachedFiles"
      class="grey-line"
      [class.display-none]="i === attachedFiles.length - 1"
    ></div>
  </div>
</div>
